import { Box, Typography } from '@mui/material';
import { FormControlProps } from '../control';
import { FormComponentBuilder } from '../index';
import useBundleTranslation from 'i18n';
import React from 'react';
import textPreview from 'app/app/editor/tabs/components/preview/text-example.svg';

export default function FormTextDescription() {
    const { t } = useBundleTranslation('form');
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                width: '100%',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                p: 2,
            }}
        >
            <Box sx={{ textAlign: 'center' }}>
                <Typography mb={1} fontWeight={600} fontSize={'14px'}>
                    {t('text_desc.title')}
                </Typography>
                <Typography mb={3}>{t('text_desc.desc')}</Typography>
                <Box component="img" src={textPreview} />
            </Box>
        </Box>
    );
}

export class FormTextDescriptionBuilder extends FormComponentBuilder {
    prepareProps(): FormControlProps {
        return {
            ...this.controlProps,
        };
    }
}
